import './categorySelection.css';
import React, { useState, useEffect } from "react";
import { confirmAlert } from 'react-confirm-alert';
import { useNavigate } from 'react-router-dom';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { JFMC } from '../../../../common/constants';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import jwt from 'jwt-decode';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';


function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
}
const images = importAll(require.context('../../../../images/', false, /\.(png|jpe?g|svg)$/));


const CategorySelection = () => {
    const { t, i18n } = useTranslation();
    // const selectedLanguage = i18n.resolvedLanguage === 'as' ? NEWS_CONTENT : NEWS;
    localStorage.removeItem('tranporterDetails');
    const navigate = useNavigate();
    const decoded = getLocalStorageItem('id_token') ? (getLocalStorageItem('id_token') == "PreReg") ? "" : jwt(getLocalStorageItem('id_token')) : "";


    const data = [
        {
            id: 1,
            img: images['bamboo-with-leaves.png'],
            title: t('preReg.grower'),
            subtitle: t('preReg.growerSub')
        },
        {
            id: 2,
            img: images['harvest.png'],
            title: t('preReg.hit'),
            subtitle: t('preReg.hitSub')
        },
        {
            id: 3,
            img: images['lle.png'],
            title: t('preReg.lle'),
            subtitle: t('preReg.lleSub')
        },
        {
            id: 4,
            img: images['cargo-truck.png'],
            title: t('preReg.transporter'),
            subtitle: ''
        },
        {
            id: 5,
            img: images['storage.png'],
            title: t('preReg.intrimStorage'),
            subtitle: ''
        }
    ]

    const subCategoryGrowers = decoded && decoded.emails && decoded.emails[0] ? ['Individual', 'FPO', , 'JFMC', 'FPC', 'SHG', 'Forest', 'Other Agency', "Co-operative"] :
        [t('preReg.individual'), t('preReg.fpo') , t('preReg.jfmc'), t('preReg.fpc'), t('preReg.shg'), t('preReg.cooperative')]
        
    const onTileClick = (selectedCategory) => {
        let tempSubCategory

        if (selectedCategory === t('preReg.grower')) {
            tempSubCategory = subCategoryGrowers
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className='category_custom-popup-container'>
                            <div className='cancel-button'> <IconButton aria-label="close" onClick={onClose}><CloseIcon /></IconButton></div>
                            <div className='custom-popup-text'>{t('preReg.subCategorySelection')}</div>
                            <div className='pill-grid-container'>
                                {tempSubCategory.map(item => (
                                    <button className='pill-grid-item-button width_auto' onClick={() => onClickSubCategory(selectedCategory, onClose, item)}>{item}</button>
                                ))}
                            </div>
                        </div>
                    );
                }
            });
        } /*else if (selectedCategory === 'HIT') {
            tempSubCategory = subCategoryHit
        } else {
            tempSubCategory = subCategoryGrowers
        }*/
        else if (selectedCategory === t('preReg.transporter')) {

            navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/transporter_details' : '/preregistration/transporter_details', { state: { category: selectedCategory } })
        }
        else if (selectedCategory === t('preReg.lle')) {

            navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/lleSubCategory' : '/preregistration/lleSubCategory', { state: { category: selectedCategory } })
        }
        else if (selectedCategory === t('preReg.hit')) {
            navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/hitSubCategory' : '/preregistration/hitSubCategory', { state: { category: selectedCategory } })
        }
        else {
            navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/tempStorageSubCategory' : '/preregistration/tempStorageSubCategory', { state: { isPreReg: true } })
        }
    }
    const onClickSubCategory = (category, close, subCategory) => {
        close();
        if (category === t('preReg.grower')) {
            if (subCategory === t('preReg.individual')) {
                navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/growerSubCategory' : '/preregistration/growerSubCategory', { state: { category: category, subCategory: subCategory } })
            } else if (subCategory === t('preReg.forest')) {
                navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/growerSubCategory' : '/preregistration/growerSubCategory', { state: { category: category, subCategory: subCategory } })
            } else if (subCategory === t('preReg.jfmc')) {
                navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/growerSubCategory' : '/preregistration/growerSubCategory', { state: { category: category, subCategory: subCategory } })
            } else {
                navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/growerSubCategory' : '/preregistration/growerSubCategory', { state: { category: category, subCategory: subCategory } })
            }
        }
    }
    return (
        <>
            <div className='main-conatiner'>
                <div className='title' > {t('preReg.subheading')}</div>
                {/* <Typography variant="h5" gutterBottom>
                Select a category of stakeholder
                    </Typography> */}
                {data.map(item => (
                    <button className='tile-container' onClick={() => onTileClick(item.title)}>
                        <div className='inner-tile-style'>
                            <img src={item.img} alt="back" className='img-style' />
                            <div className='heading-container'>
                                <div className='main-heading'>{item.title}</div>
                                <div className='sub-heading'>{item.subtitle}</div>
                            </div>

                        </div>

                    </button>
                ))}
            </div>


        </>

    )
};
export default CategorySelection;
